export default "__VITE_ASSET__jytXmTm$__"